import { useMemo } from 'react';

import { fetchEventsExportFormats } from 'api/eventsExportFormat/eventsExportFormats';
import { QueryKeyEnum } from 'core/global.enum';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { useQuery } from 'hooks/useQuery/useQuery';
import {
  EventExportFormatNameSortEnum,
  EventExportFormatQueryKeysEnum,
  QueryKeyLocalStorageEnum,
} from 'context/query/queryContext/QueryContext.enum';

import { EventsExportFormats } from './EventsExportFormats';
import { EventsExportFormatRow } from './EventsExportFormats.types';
import { SYSTEM_EVENT_EXPORT_FORMATS } from './EventsExportFormats.systemFormats';

export const EventsExportFormatsContainer = () => {
  const {
    storedQueries: { [QueryKeyLocalStorageEnum.EVENTS_EXPORT_FORMAT]: eventsExportFormatQuery },
  } = useLocaleStoreQuery();

  const typFilter = eventsExportFormatQuery[EventExportFormatQueryKeysEnum.TYP];
  const formatFilter = eventsExportFormatQuery[EventExportFormatQueryKeysEnum.FORMAT];
  const sortValue = eventsExportFormatQuery[EventExportFormatQueryKeysEnum.SORT]?.[0];

  const { data: eventsExportFormatsResponse, isLoading } = useQuery([QueryKeyEnum.EVENTS_EXPORT_FORMAT], () =>
    fetchEventsExportFormats(),
  );

  const rows = useMemo<EventsExportFormatRow[]>(() => {
    const userRows: EventsExportFormatRow[] = (eventsExportFormatsResponse?.data ?? []).map((data) => ({
      kind: 'UZYTKOWNIKA',
      id: data.id,
      nazwa: data.nazwa,
      format: '.txt',
      data,
    }));

    const merged: EventsExportFormatRow[] = [...SYSTEM_EVENT_EXPORT_FORMATS, ...userRows];

    const filtered = merged.filter((row) => {
      if (typFilter && row.kind !== typFilter) return false;
      if (formatFilter && row.format !== formatFilter) return false;
      return true;
    });

    if (!sortValue) return filtered;

    const direction = sortValue === EventExportFormatNameSortEnum.DESC ? -1 : 1;
    return [...filtered].sort((a, b) => a.nazwa.localeCompare(b.nazwa) * direction);
  }, [eventsExportFormatsResponse?.data, typFilter, formatFilter, sortValue]);

  return <EventsExportFormats eventsExportFormatsResponse={rows} isLoading={isLoading} />;
};
